/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Empty_EventInputs */

const en_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty event`)
};

const fr_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement vide`)
};

const de_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeres Ereignis`)
};

const it_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento vuoto`)
};

const ru_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пустое событие`)
};

const es_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento vacío`)
};

const zh_cn2_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空事件`)
};

const ja_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空のイベント`)
};

const hi_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली घटना`)
};

const pt_pt2_image_export_preview_empty_event = /** @type {(inputs: Image_Export_Preview_Empty_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento vazio`)
};

/**
* | output |
* | --- |
* | "Empty event" |
*
* @param {Image_Export_Preview_Empty_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_empty_event = /** @type {((inputs?: Image_Export_Preview_Empty_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Empty_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_empty_event(inputs)
	if (locale === "de") return de_image_export_preview_empty_event(inputs)
	if (locale === "it") return it_image_export_preview_empty_event(inputs)
	if (locale === "ru") return ru_image_export_preview_empty_event(inputs)
	if (locale === "es") return es_image_export_preview_empty_event(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_empty_event(inputs)
	if (locale === "ja") return ja_image_export_preview_empty_event(inputs)
	if (locale === "hi") return hi_image_export_preview_empty_event(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_empty_event(inputs)
	return en_image_export_preview_empty_event(inputs)
});